import { render, staticRenderFns } from "./GraphDetail31.vue?vue&type=template&id=1c39b938&scoped=true"
import script from "./GraphDetail31.vue?vue&type=script&lang=js"
export * from "./GraphDetail31.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39b938",
  null
  
)

export default component.exports